import ds from './DataSourceService'

const baseUrl = '/organizations'

const getOrganizations = () => {
  return ds.apiClientThinkHome.get(baseUrl)
}

const getOrganizationById = organizationId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + organizationId)
}
const getOrganizationsForUsers = () => {
  return ds.apiClientThinkHome.get(baseUrl + '/users-organizations')
}
const createOrganization = organizationId => {
  return ds.apiClientThinkHome.post(baseUrl, organizationId)
}

const createOrganizationUser = organizationUserId => {
  return ds.apiClientThinkHome.post('/organization-user', organizationUserId)
}

const createOrganizationProject = organizationProjectId => {
  return ds.apiClientThinkHome.post(
    '/organization-project',
    organizationProjectId
  )
}

const updateOrganization = organization => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + organization.id,
    organization
  )
}

const detachOrganizationUser = data => {
  return ds.apiClientThinkHome.post('/organization-user-remove', data)
}

const detachOrganizationProject = data => {
  return ds.apiClientThinkHome.post('/organization-project-remove', data)
}
const getProjectsForOrganization = async (organizationId) => {
  try {
    const response = await ds.apiClientThinkHome.get(baseUrl + '/' + organizationId + '/projects');
    console.trace('finished getting projects')
    return response;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

const getUsersForOrganization = organizationId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + organizationId + '/users')
}

export default {
  getOrganizations,
  getOrganizationById,
  createOrganization,
  createOrganizationUser,
  createOrganizationProject,
  updateOrganization,
  getProjectsForOrganization,
  getUsersForOrganization,
  getOrganizationsForUsers,
  detachOrganizationUser,
  detachOrganizationProject
}
